import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "ecomdune_ppc_visible"

export default class extends Controller {
  static targets = ["column", "btn"]

  connect() {
    const visible = localStorage.getItem(STORAGE_KEY) === "true"
    this._apply(visible)
  }

  toggle() {
    const visible = localStorage.getItem(STORAGE_KEY) !== "true"
    localStorage.setItem(STORAGE_KEY, visible)
    this._apply(visible)
  }

  _apply(visible) {
    this.columnTargets.forEach(el => el.classList.toggle("d-none", !visible))
    if (this.hasBtnTarget) {
      this.btnTarget.textContent = visible ? "Hide PPC" : "Show PPC"
    }
  }
}
